<div class="pdf-wrapper">
    <div class="pdf-header">
        <div class="pdf-user">
            @if (showAvatar !== false) {
                @if (avatarUrl) {
                    <div class="pdf-avatar">
                        <img [src]="getAvatarUrl(avatarUrl)" [alt]="title" />
                    </div>
                } @else if (title) {
                    <div class="pdf-avatar">{{ getInitials(title) }}</div>
                }
            }
            <div class="pdf-meta">
                @if (title) { <div class="pdf-name">{{ title }}</div> }
                @if (subtitle) { <div class="pdf-date">{{ subtitle }}</div> }
            </div>
        </div>
        @if (fileName) {
            <div class="pdf-filename">{{ fileName }}</div>
        }
        <div class="pdf-actions">
        </div>
    </div>
    <div class="pdf-body">
        @if (safeUrl) {
            <iframe [src]="safeUrl" class="pdf-iframe"></iframe>
        }
    </div>
</div>